import React from 'react';
import { observer } from 'mobx-react-lite';
import strings from '../../strings';
import FilterIcon from '../FilterIcon';
import * as styles from '../Filter/Filter.scss';

const EpdMedal = ({ epdMedal, handleEpdMedalClick }) => {
  const epdMedalText = strings.readyForEtrn;

  const epdMedalImgUrl = '/rating/assets/images/epd-medal-filter.svg';

  const epdMedalIcon = (
    <img
      alt="epd-medal"
      className={styles.epdMedal}
      src={epdMedalImgUrl}
    />
  );

  return (
    <FilterIcon
      icon={epdMedalIcon}
      iconSelected={epdMedalIcon}
      text={epdMedalText}
      pressed={epdMedal}
      handleClick={handleEpdMedalClick}
    />
  );
};

export default observer(EpdMedal);
